import { getUniqChunkedIds } from '@utils/getUniqChunkedIds';
import { getUniqNewIds } from '@utils/getUniqNewIds';

export function getUniqNewChunkedIds(
    currentIds: string[],
    newIds: (string | undefined)[],
    chunkSize?: number,
): string[][] {
    const ids = getUniqNewIds(currentIds, newIds);

    return getUniqChunkedIds(ids, chunkSize);
}
